import React from 'react'
import { Link } from 'react-router-dom'

const Item = ({Obj}) => {
  const User = JSON.parse(localStorage.getItem("user-info"));
  return (
    <Link to={'/admin/orders/view/'+Obj.id}>
      <div className='form_item_row_container discription'>
        <div className='form_item_row_container_itemfull' style={{width:'12%'}}>
          <p>{Obj.orderno}</p>
        </div>
        <div className='form_item_row_container_item' style={{width:'11%'}}>
          <p>{Obj.fulfilmentstatus==0?"Unfulfilled":"Fulfilled"}</p>
        </div>
        <div className='form_item_row_container_item' style={{width:'11%'}}>
          <p>{Obj.paymentstatus==0?"Unpaid":"Paid"}</p>
        </div>
        <div className='form_item_row_container_item' style={{width:'11%'}}>
          <p>{Obj.total}</p>
        </div>
        <div className='form_item_row_container_item' style={{width:'11%'}}>
          <p>{Obj.shippingcost}</p>
        </div>
        <div className='form_item_row_container_item' style={{width:'11%'}}>
          <p>{Obj.gtotal}</p>
        </div>
        <div className='form_item_row_container_item' style={{width:'11%'}}>
          <p>{Obj.commission}</p>
        </div>
        <div className='form_item_row_container_item' style={{width:'11%'}}>
          <p>{Obj.sellershipping}</p>
        </div>
        <div className='form_item_row_container_item' style={{width:'11%'}}>
          <p>{Obj.sellerpayables}</p>
        </div>
      </div>
    </Link>
    
  )
}

export default Item
